import { HashRouter } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "./App.scss";
import Routing from "./routing/Routing";
import { AxiosInterceptor } from "config/axiosInstance";
import "react-phone-input-2/lib/bootstrap.css";
import { Provider } from "react-redux";
import appStore from "store/appStore";
import "./index.css";
import { UserProvider } from "hooks/useUser";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <UserProvider>
          <Provider store={appStore}>
            <AxiosInterceptor>
              {/* <AppLogout> */}
              <Routing />
              {/* </AppLogout> */}
            </AxiosInterceptor>
          </Provider>
        </UserProvider>
      </HashRouter>
    </div>
  );
}

export default App;
